import BookingOnboarding from '@/components/public/bookingOnboarding/BookingOnboarding';

const BookingOnboardingPage = (): JSX.Element => {
    return <BookingOnboarding />;
};

export default BookingOnboardingPage;
